const DEFAULT_TERRAIN_VISUALIZATION_OPTIONS = Object.freeze({
  /** With no terrain, all three stay off; sync turns them on when standard floor terrain exists. */
  showHeatmap: false,
  /** @type {'slope' | 'height'} */
  heatmapColorMode: "slope",
  showContours: false,
  /** Heightfield-following grid (terrain only; does not replace `sceneGrid`). */
  showSurfaceGrid: false,
  /**
   * When terrain preset or total height changes, reposition world-root objects so they stay on the
   * surface (same bottom correction as after an asset-library drop).
   */
  liftBodiesWithTerrainEdits: false,
});

let terrainVisualizationOptions = { ...DEFAULT_TERRAIN_VISUALIZATION_OPTIONS };
const listeners = new Set();

/** @type {boolean | undefined} */
let prevStandardFloorTerrainPresence;

export function getTerrainVisualizationOptions() {
  return terrainVisualizationOptions;
}

export function subscribeTerrainVisualizationOptions(listener) {
  listeners.add(listener);
  return () => listeners.delete(listener);
}

export function setTerrainVisualizationOptions(patch) {
  const nextOptions = {
    ...terrainVisualizationOptions,
    ...patch,
  };
  if (
    nextOptions.showHeatmap === terrainVisualizationOptions.showHeatmap &&
    nextOptions.heatmapColorMode === terrainVisualizationOptions.heatmapColorMode &&
    nextOptions.showContours === terrainVisualizationOptions.showContours &&
    nextOptions.showSurfaceGrid === terrainVisualizationOptions.showSurfaceGrid &&
    nextOptions.liftBodiesWithTerrainEdits ===
      terrainVisualizationOptions.liftBodiesWithTerrainEdits
  ) {
    return;
  }
  terrainVisualizationOptions = nextOptions;
  listeners.forEach((listener) => listener());
}

/**
 * When standard floor terrain is added or removed, sync terrain-only visualization toggles so
 * nothing stays "on" with a flat floor; when terrain appears heatmap, contours, and grid default on.
 * @param {boolean} hasStandardFloorTerrain
 */
export function syncTerrainVisualizationForStandardFloorPresence(hasStandardFloorTerrain) {
  if (
    prevStandardFloorTerrainPresence !== undefined &&
    hasStandardFloorTerrain === prevStandardFloorTerrainPresence
  ) {
    return;
  }
  prevStandardFloorTerrainPresence = hasStandardFloorTerrain;
  if (!hasStandardFloorTerrain) {
    setTerrainVisualizationOptions({
      showHeatmap: false,
      showContours: false,
      showSurfaceGrid: false,
    });
  } else {
    setTerrainVisualizationOptions({
      showHeatmap: true,
      showContours: true,
      showSurfaceGrid: true,
    });
  }
}
